<div *ngIf="!isHeader" class="row text-center footer m-0">
    <div class="col-md-12">
    © CIRCOR INTERNATIONAL, INC. ALL RIGHTS RESERVED, 2022.
    </div>
</div>